import { Switch } from '@components/core-ui/form-elements/Switch';
import { TProps } from '@components/core-ui/form-elements/Switch/types/TProps';

export const AvatarThemeSwitch = ({ checked = false, className = 'switch', ...rest }: TProps) => (
  <Switch
    {...rest}
    checked={checked}
    className={[
      className,
      '[&_.switch-track]:!bg-[var(--color-border)]',
      '[&.is-on_.switch-track]:!bg-[var(--color-accent)]',
      '[&_.point]:!bg-[var(--color-surface)]',
      '[&.is-on_.point]:!bg-[var(--color-fixed-white)]',
      checked ? 'is-on' : '',
    ]
      .filter(Boolean)
      .join(' ')}
  />
);
